import { createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`
@font-face {
    font-family: 'Editor Regular';
    src: url('/fonts/Editor-Regular.otf') format('opentype');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'Editor Light';
    src: url('/fonts/Editor-Light.otf') format('opentype');
    font-weight: normal;
    font-style: normal;
}

body {
    margin: 0;
    padding: 0;
    font-family: "Montserrat", sans-serif;
    color: #4a4a4a;
}
`

export default GlobalStyle



// WEBPACK FOOTER //
// ./src/components/layout/GlobalStyle.js